/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Common API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { ApiResponseXmServerProperty, NowResponse, ResultResponse } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary ping
 */
export const getV7HealthCheck = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ResultResponse>(
    { url: `/api/v7/healthCheck`, method: 'GET', signal },
    options,
  );
};

export const getGetV7HealthCheckQueryKey = () => {
  return ['api', 'v7', 'healthCheck'] as const;
};

export const getGetV7HealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7HealthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7HealthCheck>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7HealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7HealthCheck>>> = ({ signal }) =>
    getV7HealthCheck(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7HealthCheck>>,
    TError,
    TData
  >;
};

export type GetV7HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getV7HealthCheck>>>;
export type GetV7HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary ping
 */

export function useGetV7HealthCheck<
  TData = Awaited<ReturnType<typeof getV7HealthCheck>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7HealthCheck>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7HealthCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary now
 */
export const getV7Now = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<NowResponse>({ url: `/api/v7/now`, method: 'GET', signal }, options);
};

export const getGetV7NowQueryKey = () => {
  return ['api', 'v7', 'now'] as const;
};

export const getGetV7NowQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7Now>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Now>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NowQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7Now>>> = ({ signal }) =>
    getV7Now(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7Now>>,
    TError,
    TData
  >;
};

export type GetV7NowQueryResult = NonNullable<Awaited<ReturnType<typeof getV7Now>>>;
export type GetV7NowQueryError = ErrorType<unknown>;

/**
 * @summary now
 */

export function useGetV7Now<
  TData = Awaited<ReturnType<typeof getV7Now>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Now>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NowQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Yaml, 및 DB에 저장된 Property 조회
 */
export const getV7Property = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseXmServerProperty>(
    { url: `/api/v7/property`, method: 'GET', signal },
    options,
  );
};

export const getGetV7PropertyQueryKey = () => {
  return ['api', 'v7', 'property'] as const;
};

export const getGetV7PropertyQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7Property>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Property>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PropertyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7Property>>> = ({ signal }) =>
    getV7Property(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7Property>>,
    TError,
    TData
  >;
};

export type GetV7PropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getV7Property>>>;
export type GetV7PropertyQueryError = ErrorType<unknown>;

/**
 * @summary Yaml, 및 DB에 저장된 Property 조회
 */

export function useGetV7Property<
  TData = Awaited<ReturnType<typeof getV7Property>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Property>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PropertyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
